import api from './api';

const connectorsettingsService = {
  getAllConnectorSettings: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      if (filters.CONNECTORID) params.append('CONNECTORID', filters.CONNECTORID);
      if (filters.ACCOUNTID) params.append('ACCOUNTID', filters.ACCOUNTID);
      if (filters.SETTINGNAME) params.append('SETTINGNAME', filters.SETTINGNAME);

      const response = await api.get(`/connectorsettings?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching connector settings:', error);
      throw error;
    }
  },

  getConnectorSettingById: async (id) => {
    try {
      const response = await api.get(`/connectorsettings/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching connector setting ${id}:`, error);
      throw error;
    }
  },

  createConnectorSetting: async (settingData) => {
    try {
      const cleanedData = Object.fromEntries(
        Object.entries(settingData).map(([key, value]) => [
          key,
          value === '' ? null : value
        ])
      );

      const response = await api.post('/connectorsettings', cleanedData);
      return response.data;
    } catch (error) {
      console.error('Error creating connector setting:', error);
      throw error;
    }
  },

  updateConnectorSetting: async (id, settingData) => {
    try {
      const cleanedData = Object.fromEntries(
        Object.entries(settingData).map(([key, value]) => [
          key,
          value === '' ? null : value
        ])
      );

      const response = await api.put(`/connectorsettings/${id}`, cleanedData);
      return response.data;
    } catch (error) {
      console.error(`Error updating connector setting ${id}:`, error);
      throw error;
    }
  },

  deleteConnectorSetting: async (id) => {
    try {
      const response = await api.delete(`/connectorsettings/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting connector setting ${id}:`, error);
      throw error;
    }
  }
};

export default connectorsettingsService;
